import { css } from 'styled-components';
// Bold
import caveat700woff from '../../../../client/fonts/caveat/Caveat-Bold.woff';
import caveat700woff2 from '../../../../client/fonts/caveat/Caveat-Bold.woff2';
const caveat = css `
  @font-face {
    font-family: 'Caveat';
    font-weight: 700;
    font-style: normal;
    font-display: swap;
    src: url(${caveat700woff2}) format('woff2'), url(${caveat700woff});
  }
`;
export default caveat;
